/* eslint-disable */ import { $DomainEntityReflection, EnhancedAliasReflection } from '@salsita-ai/platform-project-sdk/domain';
import { Admin, CabinetMaterial, CabinetSolidColorMaterial, CabinetWoodTextureMaterial, CountertopMaterial, CountertopSolidColorMaterial, CountertopWoodTextureMaterial, DummyDoNotUse, Preset, PresetCategory, Recipe, SegmentPrice } from './admin-model/index.js';
export const constants = {
    CabinetWoodTextureMaterial: {
        $woodSwatches: {
            lightWoodMaterial: {
                color: '#000000',
                thumbnailUrl: '/swatches/oak.png',
                swatchName: 'Oak'
            },
            darkWoodMaterial: {
                color: '#000000',
                thumbnailUrl: '/swatches/dark-wood.png',
                swatchName: 'Dark wood'
            },
            whiteWoodMaterial: {
                color: '#000000',
                thumbnailUrl: '/swatches/white-wood.png',
                swatchName: 'White wood'
            }
        }
    },
    CountertopWoodTextureMaterial: {
        $woodSwatches: {
            butcherBlockMaterial: {
                color: '#000000',
                thumbnailUrl: '/swatches/butcher-block.png',
                swatchName: 'Butcher block'
            }
        }
    }
};
const WoodTextureMaterialExpressions = [
    '$woodSwatch'
];
const MaterialExpressions = [
    '$swatchUrl',
    '$name',
    '$description'
];
const PresetCategoryExpressions = [
    '$isDraft',
    '$admin',
    '$presets'
];
const AdminExpressions = [
    '$segmentPrices',
    '$cabinetMaterials',
    '$countertopMaterials',
    '$presets',
    '$presetCategories',
    '$recipes'
];
const PresetExpressions = [
    '$admin',
    '$category',
    '$violations'
];
const RecipeExpressions = [
    '$admin'
];
const CabinetWoodTextureMaterialExpressions = [
    '$woodSwatches'
];
const CountertopWoodTextureMaterialExpressions = [
    '$woodSwatches'
];
export const $Admin = new $DomainEntityReflection('Admin', [
    ...AdminExpressions
]);
export const $Preset = new $DomainEntityReflection('Preset', [
    ...PresetExpressions
]);
export const $PresetCategory = new $DomainEntityReflection('PresetCategory', [
    ...PresetCategoryExpressions
]);
export const $Recipe = new $DomainEntityReflection('Recipe', [
    ...RecipeExpressions
]);
export const $DummyDoNotUse = new $DomainEntityReflection('DummyDoNotUse', []);
export const $CabinetSolidColorMaterial = new $DomainEntityReflection('CabinetSolidColorMaterial', [
    ...MaterialExpressions
]);
export const $CabinetWoodTextureMaterial = new $DomainEntityReflection('CabinetWoodTextureMaterial', [
    ...CabinetWoodTextureMaterialExpressions,
    ...WoodTextureMaterialExpressions,
    ...MaterialExpressions
]);
export const $CountertopSolidColorMaterial = new $DomainEntityReflection('CountertopSolidColorMaterial', [
    ...MaterialExpressions
]);
export const $CountertopWoodTextureMaterial = new $DomainEntityReflection('CountertopWoodTextureMaterial', [
    ...CountertopWoodTextureMaterialExpressions,
    ...WoodTextureMaterialExpressions,
    ...MaterialExpressions
]);
export const $SegmentPrice = new $DomainEntityReflection('SegmentPrice', []);
export const $AnyDomainEntity = new EnhancedAliasReflection('$AnyDomainEntity', [
    Admin.type,
    Preset.type,
    PresetCategory.type,
    Recipe.type,
    DummyDoNotUse.type,
    CabinetSolidColorMaterial.type,
    CabinetWoodTextureMaterial.type,
    CountertopSolidColorMaterial.type,
    CountertopWoodTextureMaterial.type,
    SegmentPrice.type
]);
export const $RootEntity = new EnhancedAliasReflection('$RootEntity', [
    Admin.type
]);
export const $CommonAdminEntity = new EnhancedAliasReflection('$CommonAdminEntity', [
    Admin.type,
    Preset.type,
    PresetCategory.type,
    Recipe.type
]);
export const $SolidColorMaterial = new EnhancedAliasReflection('$SolidColorMaterial', [
    CabinetSolidColorMaterial.type,
    CountertopSolidColorMaterial.type
]);
export const $WoodTextureMaterial = new EnhancedAliasReflection('$WoodTextureMaterial', [
    CabinetWoodTextureMaterial.type,
    CountertopWoodTextureMaterial.type
]);
export const $CabinetMaterial = new EnhancedAliasReflection('$CabinetMaterial', [
    CabinetSolidColorMaterial.type,
    CabinetWoodTextureMaterial.type
]);
export const $CountertopMaterial = new EnhancedAliasReflection('$CountertopMaterial', [
    CountertopSolidColorMaterial.type,
    CountertopWoodTextureMaterial.type
]);
export const $Material = new EnhancedAliasReflection('$Material', [
    ...CabinetMaterial.types,
    ...CountertopMaterial.types
]);
export const $entityReflections = {
    Admin: $Admin,
    Preset: $Preset,
    PresetCategory: $PresetCategory,
    Recipe: $Recipe,
    DummyDoNotUse: $DummyDoNotUse,
    CabinetSolidColorMaterial: $CabinetSolidColorMaterial,
    CabinetWoodTextureMaterial: $CabinetWoodTextureMaterial,
    CountertopSolidColorMaterial: $CountertopSolidColorMaterial,
    CountertopWoodTextureMaterial: $CountertopWoodTextureMaterial,
    SegmentPrice: $SegmentPrice
};

//# sourceMappingURL=admin-enhanced-model.js.map